<template>
  <div>
    标题：<el-input v-model="addNewInfoVo.ntitle" placeholder="请输入标题"></el-input>
    <br />
    <br />
    文章地址：<el-input v-model="addNewInfoVo.nnewsUrl" placeholder="请输入文章地址"></el-input>
    <br />
    <br />
    新闻所属医院：
    <el-select v-model="ruleForm.procedure_type" placeholder="请选择" @change="changeSelect">
     <el-option
       v-for="(item,i) in procedureType"
       :key="i"
       :label="item"
       :value="item"
     >
     </el-option>
   </el-select>
   新闻所属类型：
   <el-select v-model="ruleForm.cause_group" placeholder="请选择" @change="chooseType">
     <el-option
       v-for="item in causeGroup"
       :key="item.value"
       :label="item.label"
       :value="item.value"
     >
     </el-option>
   </el-select>
    <br />
    <br />
    封面：
    <el-upload ref="imgUpload" :on-success="imgSuccess"
      accept="image/jpeg,image/jpg,image/png,image/svg" name="files" :headers="headerMsg"
      :action="upLoadUrl" :limit="limit">
      <el-button type="primary">上传图片</el-button>
    </el-upload>
    <br />
    <el-button type="success" @click="release">发布文章</el-button>
  </div>
</template>

<script>
  import Global from "./Global";

  export default {
    name: "NewsAdd",
    mounted() {
      this.getNewsType();
    },
    data() {
      return {
        addNewInfoVo: {
          ntitle: '',
          nnewsUrl: '',
          coverUrl: ''
        },
        // 上传图片的信息
        headerMsg: {},
        upLoadUrl: Global.yunyingUrl + '/system/news/uploadImageForNews',
        // 编辑器内容
        content: '',
        editorData: '',
        newsType: {},
        type: 1,
        value: '',
        newsGroup:'',
        limit: 1,
        // 在这里定义所需的值
      procedureType: ["思多科", "复塑"],
      TypeObj: {
        思多科: [{value:"1",label:"科普文章"},
                {value:"2",label:"活动剪影"},
                {value:"3",label:"甄选产品"},
                
              ],
        复塑:  [{value:"5",label:"科普教学"},
                {value:"6",label:"精彩活动"},
                {value:"7",label:"甄选产品"},
                
              ],
      },
      ruleForm: {
        procedure_type: "",
        cause_group: "",
      },
      // 由 changeSelect 接管 causeGroup 的值
      causeGroup: [],
      
      SSID: '',
      options: [
        {
        value: '思多科',
        label: '思多科'
      },
      {
        value: '复塑',
        label: '复塑'
      }],
      group:''
      }
    },
    methods: {
      //添加新闻的方法
      release() {
        let that = this;
        that.axios({
          method: 'post',
          url: Global.yunyingUrl + '/system/news/addNews',
          data: {
            title: that.addNewInfoVo.ntitle,
            newsGroup: that.newsGroup,
            type: that.type,
            cover_url: that.addNewInfoVo.coverUrl,
            news_url: that.addNewInfoVo.nnewsUrl
          }
        }).then(function (response) {
          if (response.data.code == 1000) {
            that.$message('发布成功');
          } else {
            that.$message.error(response.data.data);
          }
        });
      },
      //绑定选框
      changeSelect(val) {
      // 联动子级滞空
      this.ruleForm.cause_group = "";
      this.newsGroup = val
      // 循环遍历父级
      for (const k in this.procedureType) {
        if (this.ruleForm.procedure_type === this.procedureType[k]) {
        // 核心代码在这里 进行赋值操作
          this.causeGroup = this.TypeObj[this.ruleForm.procedure_type];
        }
      }
    },
      // 获取编辑器内容
      getEditorContent(data) {
        this.editorData = data;
      },
      // 上传图片成功
      imgSuccess(res, file, fileList) {
        this.addNewInfoVo.coverUrl = res.data[0].url;
      },
      // 获取新闻可选类型
      getNewsType() {
        let that = this;
        that.axios({
          method: 'get',
          url: Global.yunyingUrl + '/system/news/getNewsType',
        }).then(
          function (response) {
            if (response.data.code == 1000) {
              that.newsType = response.data.data;
            } else {
              that.$message.error(response.data.data);
            }
          }
        );
      },
      // 选择新闻类型
      chooseType(val) {
        this.type = val;
      },
      //绑定SSID
      bindGroup() {
      let SSID = this.SSID
      let group = this.group
      this.axios({
        method: 'POST',
        url: Global.accountUrl + '/probeRent/updateProbeGroup',
        data: {
          'ssid': SSID,
          'group': group
        }
      }).then(resp => {
        let data = resp.data
        if (data.code === 200) {
          this.$message.success('绑定医院成功')
        } else {
          this.$message.error(data.msg)
        }
      })
    }
    },
  }

</script>



// WEBPACK FOOTER //
// src/components/NewsAdd.vue